import { c as _c } from "react/compiler-runtime";
import { Button as ButtonHeadlessUI } from '@headlessui/react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading';
import { cn } from '@/frontend/utils';
export enum WEEK_DAYS {
  MONDAY = 'Poniedziałek',
  TUESDAY = 'Wtorek',
  WEDNESDAY = 'Środa',
  THURSDAY = 'Czwartek',
  FRIDAY = 'Piątek',
  SATURDAY = 'Sobota',
  SUNDAY = 'Niedziela',
}
interface HourSelectorProps {
  activeTab: WEEK_DAYS;
  selectedHoursByDay: Record<WEEK_DAYS, string[]>;
  toggleHourForActiveDay: (hour: string) => void;
}
const generateHours = () => Array.from({
  length: 14
}, (_, h) => 8 + h).flatMap(h => [0, 30].map(m => `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`)).filter(t => t <= '21:30');
export function HourSelector(t0) {
  const $ = _c(8);
  const {
    activeTab,
    selectedHoursByDay,
    toggleHourForActiveDay
  } = t0;
  let t1;
  let t2;
  if ($[0] !== activeTab || $[1] !== selectedHoursByDay || $[2] !== toggleHourForActiveDay) {
    const hours = generateHours();
    t1 = "custom-scrollbar grid max-h-120 grid-cols-3 gap-3 overflow-y-auto sm:grid-cols-4 lg:grid-cols-8";
    t2 = hours.map(hour => {
      const isChecked = selectedHoursByDay[activeTab].includes(hour);
      return <ButtonHeadlessUI key={hour} className={cn("flex h-fit items-center justify-center gap-2 rounded-md border border-borderPrimary bg-backgroundSecondary p-4", isChecked && "border-blue-100 bg-blue-50")} onClick={() => toggleHourForActiveDay(hour)}><H4 className={cn("text-contentSecondary", isChecked && "text-contentBlue")}>{hour}</H4>{isChecked && <ArrowPathIcon className="h-4 w-4 flex-none text-contentBlue" />}</ButtonHeadlessUI>;
    });
    $[0] = activeTab;
    $[1] = selectedHoursByDay;
    $[2] = toggleHourForActiveDay;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <section className={t1}>{t2}</section>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}